module.exports = __webpack_public_path__ + "static/img/yunsun-face.6d409cbb.png";